/* eslint-disable */
import getStore from '@ve/services/getStore/getStore';
import Vue from 'vue';

import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';
import ls from 'local-storage';
import AbstractSearchController from "@/js/desktop/Domain/Abstract/SearchController";
import SearchFormHotTours from "@fr/pages/desktop/travelata/travelata/hot-tours/components/SearchFormHotTours";
import fromRouterHotHydrator from "@/js/common/Domain/Hydrator/fromRouterHot";
import toRouterHotHydrator from "@/js/common/Domain/Hydrator/toRouterHot";
import toLocalStorageTourCriteriaHydrator from "@/js/common/Domain/Hydrator/toLocalStorageTourCriteria";
import CountriesRepository from "@/js/common/Domain/Repository/Countries";
import ResortsRepository from "@/js/common/Domain/Repository/Resorts";
import SearchRequestFactory from "@/js/common/Domain/Factory/SearchRequest";
import "@fr/src/css/desktop/search/destination-info-atlas.css"


import "./styles/hot-advantages.scss"
import "./styles/hot-info.scss"
import "./styles/hot-links.scss"
import "./styles/hot-static.scss"
import "./styles/hot-tour-block.scss"
import "./styles/hotTours.css"
import SearchPageHotView from "@/js/desktop/View/SearchPageHot";

import hotelTemplate from "@/js/desktop/View/searchPageHotel/hotelTemplate.html"
import "@/js/desktop/View/searchPageHotel/serpHotelCard/serpHotelCard.scss";
import SearchResultInfo	from "./components/searchResultInfo/SearchResultInfo";

import SearchPageHotelHotView from "./components/SearchPageHotelHotView";

import SearchPageModel from "@/js/desktop/Domain/Model/SearchPageModel";

import DataLayerAnalytics from "@/js/common/Domain/Service/DataLayerAnalytics";
import SocialButtons from "@/js/desktop/components/social-btns";
import Search from '@/js/common/Domain/Service/Search';
import HotelFactory from '@/js/common/components/hot-tours/Domain/Factory/HotToursHotel';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';

import CountryConditions from '@ve/components/countryConditions/desktop/CountryConditions.vue';

var Controller = AbstractSearchController.extend({
	mindboxTracking() {
		mindBoxService.trackViewSerp('serp_hot', this.model, this.view.model);
	},
	initDataAnalyticsService(){
		this.dataLayerAnalytics = new DataLayerAnalytics({
			step: "searchHot",
			maxStep: 1,
			isHotTourView: true
		});
	},
	initAdditionalViews(){
		new SearchResultInfo({
			el: ".searchResultInfo",
			parent: this
		})
	},
	initSearchPageView() {
		this.view = new SearchPageHotView({
			el: '#forSearchView',
			searchFormViewModel: this.model,
			hotelTemplate,
			SearchPageHotelView: SearchPageHotelHotView,
			SearchPageModel: SearchPageModel,
			dataLayerAnalytics: this.dataLayerAnalytics,
			withoutStatic: !!window.appConfig.withoutStatic
		});
	},
	initSearchForm: function () {
		this.searchFormView = new SearchFormHotTours();
	},
	initGallery:function() {
		$('.imageGallery')
			.on('jcarousel:create jcarousel:reload', function() {
				var element = $(this),
					width = element.innerWidth();
				element.jcarousel('items').css('width', width + 'px');
			})
			.jcarousel();

		$('.imageGallery-pagination').jcarouselPagination({
			item: function(page, $image) {
				return '<span style="background-image:url(' + $image.data('preview') + ')"> </span>';
			}
		});

		$('.imageGallery-pagination')
			.on('jcarouselpagination:active', 'span', function() {
				$(this).addClass('active');
			})
			.on('jcarouselpagination:inactive', 'span', function() {
				$(this).removeClass('active');
			});

		if (!$(".imageGallery-pagination span.active").length) {
			$(".imageGallery-pagination span:first-child").addClass("active");
		}
	},
	initSocialButtons() {
		new SocialButtons({
			el: '.social-btns'
		});
	},
	fromRouterHydrator: fromRouterHotHydrator,
	toRouterHydrator: toRouterHotHydrator,
	getAdditionalData: function () {
		var tourCriteriaFromLocalStorage = ls.get('tourCriteria' + document.location.pathname);

		return tourCriteriaFromLocalStorage || {};
	},
	storeCriteria: function (tourCriteria) {
		var paramsForLocalStorage = toLocalStorageTourCriteriaHydrator(tourCriteria);

		if (typeof (ls) !== 'undefined') {
			ls.set('tourCriteria/tury', paramsForLocalStorage);
		}
	},
	initCountryInfo() {}, //Инициализация компоненты CountriesBannerInfo не должна происходит на странице Hot search
	activateAlternativeSearch() {}, //Инициализация компоненты AlternativeDeparture не должна происходит на странице Hot search
	activatePopularityOffersFilters() {},
	initConditionCountry() {
		const store = getStore({
            name: 'mapForCountryConditions',
            backboneMap: [
                {
                    fields: [{
                        countries: {
                            field: 'searchData',
                            action: (model, searchData) => searchData?.get('countries')?.pluck('id'),
                        },
                    }],
                    model: this.model,
                },
            ],
        });
		new Vue({
			name: 'CountryConditions',
            el: '.js-country-conditions',
            render: (h) => h(CountryConditions, {
				props: {
					isHotTours: true,
				}
			}),
            store,
        });
	},
	prepareSearchRequests(tourCriteria) {
		let searchServiceParamsCollection = [],
			tourCriteriaCountries = tourCriteria.get('countries')?.models;
		_.each(tourCriteriaCountries,  (country, index) => {
			var newTourCritetia = tourCriteria.clone(),
				type = index === 0 ? 'both' : 'sync';

			newTourCritetia.set('countries', new CountriesRepository(country));
			/***Fix for russia countries***/
			if (country.get('id') === 76 && tourCriteriaCountries.length > 1) {
				newTourCritetia.set('resorts', new ResortsRepository([
					{id: 3097}, //Big Sochi
					{id: 1691} //Krasnaya Polyana
				]));
			}
			/**/
			if (tourCriteriaCountries.length > 1) {
				searchServiceParamsCollection.push(new SearchRequestFactory(newTourCritetia, type, null, 200));
			} else {
				searchServiceParamsCollection.push(new SearchRequestFactory(newTourCritetia));
			}

		});

		return searchServiceParamsCollection;
	},
	initSearchService() {
		this.searchService = new Search({HotelFactory});
	},
});

$(function () {
	new Controller({
		el: 'body'
	});
});

